import React from 'react';
import RootSvg, { RootSvgProps } from '@/components/icons/RootSvg';

export default function SvgTear(props: RootSvgProps) {
  return (
    <RootSvg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M29.0625 7.85742C30.7719 6.22509 33.4551 6.28031 35.0996 8.02148L36.0654 9.05957C38.4836 11.6958 41.976 15.7868 45.0205 20.4463C48.4655 25.7188 51.5 31.9599 51.5 37.7451C51.5 48.6355 42.7894 57.5 32 57.5C21.2106 57.5 12.5 48.6355 12.5 37.7451C12.5 31.9599 15.5345 25.7188 18.9795 20.4463C22.4588 15.1213 26.5231 10.5386 28.9004 8.02148L29.0625 7.85742Z"
        fill="#FA8C16"
        stroke="black"
        strokeWidth="3"
      />
      <path
        d="M38.5 44.5V44C38.5 39.5 35.3137 37.5 32 37.5C28.6863 37.5 25.5 39.5 25.5 44L25.5 44.5"
        stroke="black"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <circle cx="37" cy="31" r="2" fill="black" />
      <circle cx="37" cy="31" r="2" fill="black" />
      <circle cx="37" cy="31" r="2" fill="black" />
      <circle cx="37" cy="31" r="2" fill="black" />
      <circle cx="27" cy="31" r="2" fill="black" />
      <circle cx="27" cy="31" r="2" fill="black" />
      <circle cx="27" cy="31" r="2" fill="black" />
      <circle cx="27" cy="31" r="2" fill="black" />
    </RootSvg>
  );
}
